export const NOT_FOUND_TEXT = {
  title: '화면을 찾을 수 없습니다',
  description: '주소가 바뀌었거나 없는 화면입니다.',
  goHome: '처음으로',
} as const;
